import Vue from 'vue';
import iView from 'view-design';
import { router } from './router/index';
import store from './store';
import App from './App.vue';
import ElementUI from 'element-ui';
import JsonViewer from 'vue-json-viewer'
import UmyUi from 'umy-ui'
import VxeUI from 'vxe-pc-ui'
import 'vxe-pc-ui/lib/style.css'
import VxeUITable from 'vxe-table'
import 'vxe-table/lib/style.css'
import 'umy-ui/lib/theme-chalk/index.css';// 引入样
import 'element-ui/lib/theme-chalk/index.css';
import 'view-design/dist/styles/iview.css';
import './styles/main.css';
import './assets/funnel/iconfont.css'
import './assets/iconfont/iconfont.css'
import './assets/icon/iconfont.css'
import './assets/adicon/iconfont.css'
import './assets/adClass/iconfont.css'
import './assets/icon-query/iconfont.css'
import './assets/LTVicon/iconfont.css'
import './assets/icons/iconfont.css'
import './assets/iconCustom/iconfont.css'
import './assets/iconChannel/iconfont.css'
import "./assets/iconAttr/iconfont.css"
import "./assets/datalinkicon/iconfont.css"
import './assets/play-icon/iconfont.css'
import './assets/quality-icon/iconfont.css'
import './editor.css'
import './assets/new-icon/iconfont.css'
import './assets/new2-icon/iconfont.css'
import './assets/new3-icon/iconfont.css'
import './assets/DINAlternateBold/iconfont.css'
import VueI18n from 'vue-i18n';
import * as echarts from "echarts"

echarts.registerTheme('myCustomTheme', {
  grid: {
    left: '10px',
    right: '10px',
    containLabel: true
  },
  color: [
    '#0084FF',   // 你的第1个颜色
    '#10BC80',   // 第2个
    '#F77234',
    '#F7BA1E',
    '#9369FF',
    '#9FDB1D',
    '#FF0067',
    '#FADC19',
    '#c23531', '#2f4554', '#61a0a8', '#d48265',
    '#91c7ae', '#749f83', '#ca8622', '#bda29a',
    '#6e7074', '#546570', '#c4ccd3', '#f4a261',
    '#e76f51', '#2a9d8f', '#264653', '#e9c46a',
    '#3CF94B', '#E70F3D', '#187ADA', '#C2E43B', '#D73EE6',
    '#23E199', '#CC571E', '#312BCC', '#49EE10', '#E52990',
    '#2DD2F1', '#EED00B', '#9F26F7', '#39F76F', '#E22526',
    '#275FE1', '#9ADB3E', '#E93CD5', '#28D3B5', '#E48F2E',
    '#6A3DF8', '#1AE90F', '#D41959', '#239BE0', '#E2F222',
    '#B123D8', '#15D272', '#D93B14', '#4554EB', '#69CC2B',
    '#DF1DA1', '#40D2D7', '#D1A21A', '#852DF2', '#17E437',
    '#DA2941', '#3979D0', '#A3DB14', '#EF2AF1', '#1DD49D',
    '#F68131', '#4732EB', '#64F345', '#E73B8C', '#22ADD9',
    '#D2C91E', '#AF43E8', '#21F96F', '#F93829', '#1F48DA'

    // 可以继续写更多颜色，或者不写让它循环
    // 也可以添加其他样式：backgroundColor, textStyle 等
  ],
  // 可选：其他全局样式
  backgroundColor: '#ffffff',
  textStyle: {
    color: '#1d2129'
  }
})
console.log(echarts, 'echarts')
/* 自定义全局组件 */
import components from '@/views/my-components'
if (process.env.NODE_ENV === 'production') {
  Vue.prototype.cache = true //全局定义⼀个实例属性
} else if (process.env.NODE_ENV === 'development') {
  Vue.prototype.cache = false
} else {
  Vue.prototype.cache = true
}
Vue.use(components);
Vue.use(VxeUI)
Vue.use(VxeUITable)
Vue.use(VueI18n);
Vue.use(iView);
Vue.use(ElementUI);
Vue.use(JsonViewer);
Vue.use(UmyUi);

Vue.config.productionTip = false

export default new Vue({
  el: '#app',
  router: router,
  store: store,
  render: h => h(App),
  data: {
    currentPageName: ''
  },
  mounted() {
    this.currentPageName = this.$route.name;
    // 显示打开的页面的列表
    this.$store.commit('setOpenedList');
    this.$store.commit('initCachepage');
  },
  created() {
  }
});



// WEBPACK FOOTER //
// ./src/main.js